import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import pulseLogoBlack from '../../img/pulseCIO_black_logo.png';
import pulseLogoWhite from '../../img/pulseCIO_blanc_logo.png';

const Footer = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const el = document.documentElement;
    const update = () => setIsDark(el.classList.contains('dark'));
    // initial value
    update();
    // watch for class changes (in case dark mode is toggled after mount)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.attributeName === 'class') {
          update();
          break;
        }
      }
    });
    observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const gradientStyle = isDark
    ? {
        backgroundImage:
          'linear-gradient(180deg, rgba(17,24,39,var(--tw-bg-opacity,1)) 0%, rgba(var(--primary-rgb), var(--footer-gradient-opacity, 0.12)) 100%)',
      }
    : { backgroundColor: '#ffffff' };

  return (
    <footer
      style={gradientStyle}
    className="text-primary py-8 mt-8 border-t border-gray-300 dark:border-gray-700 shadow-inner"
      aria-label="Pied de page"
    >
      <div className="container mx-auto px-4 md:flex md:items-start md:justify-between">
        <div className="flex flex-col items-center md:items-start md:w-1/4">
          <div className="mr-3">
            {/* Use two raster logos and let Tailwind's dark: utility toggle visibility */}
            <Link to="/" aria-label="Accueil" className="inline-flex items-center">
              <img
                src={pulseLogoBlack}
                alt="PulseCIO"
                className="w-auto h-5 block dark:hidden"
                style={{ filter: 'var(--footer-logo-filter)' }}
              />
              <img
                src={pulseLogoWhite}
                alt="PulseCIO"
                className="w-auto h-5 hidden dark:block"
                style={{ filter: 'var(--footer-logo-filter)' }}
              />
            </Link>
          </div>
          <div className="text-xs mt-3">
            <div className="text-primary/90">© {new Date().getFullYear()} Mathieu Lalande</div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-6 md:mt-0 md:w-3/4 text-sm">
          <div>
            <h4 className="font-semibold mb-2 dark:text-white text-black">Produit</h4>
            <Link to="/about" className="block hover:underline text-primary/90">À propos</Link>
            <Link to="/status" className="block hover:underline text-primary/90">Status</Link>
            <a
              href="https://doc.pulsecio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:underline text-primary/90"
            >
              Documentation
            </a>
            <a
              href="https://pulsecio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:underline text-primary/90"
            >
              Vitrine
            </a>
          </div>

          <div>
            <h4 className="font-semibold mb-2 dark:text-white text-black">Légal</h4>
            <Link to="/legal" className="block hover:underline text-primary/90">Mentions légales</Link>
            <Link to="/privacy" className="block hover:underline text-primary/90">Politique de confidentialité</Link>
            <Link to="/cookies" className="block hover:underline text-primary/90">Cookies</Link>
            <Link to="/terms" className="block hover:underline text-primary/90">CGU</Link>
          </div>

          <div>
            <h4 className="font-semibold mb-2 dark:text-white text-black">Support</h4>
            <a
              href="mailto:contact@pulsecio.com"
              className="block hover:underline text-primary/90"
            >
              Contact
            </a>
            <a
              href="https://pulsecio.com/#faq"
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:underline text-primary/90"
            >
              FAQ
            </a>
            <a
              href="mailto:contact@pulsecio.com?subject=Signalement%20d%27un%20probl%C3%A8me"
              className="block hover:underline text-primary/90"
            >
              Signaler un problème
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;